import React from 'react';
import { POPULAR_EV_MODELS } from '@/lib/constants';
import { slugify } from '@/lib/utils';
import { ResponsiveWrapper } from '@/components/atoms/ResponsiveWrapper/ResponsiveWrapper';
import Accordion from '@/components/molecules/Accordion';

interface PopularModelsLinksProps {
  /** 'new' or 'used' - determines which page to link to */
  condition?: 'new' | 'used';
}

export const PopularModelsLinks: React.FC<PopularModelsLinksProps> = ({
  condition = 'new',
}) => {
  const conditionSlug = condition === 'new' ? 'new-cars' : 'used-cars';

  return (
    <ResponsiveWrapper>
      <div className="mx-auto flex max-w-[980px] flex-col gap-xl py-[80px]">
        <div className="border-b border-neutral-200 pb-l">
          <Accordion
            buttonClassName="text-neutral-900 text-h4Regular"
            icon={{ id: 'chevron' }}
            title="Search popular EVs by model"
          >
            <div className="columns-3 space-y-m py-s">
              {POPULAR_EV_MODELS.map((model) => {
                const href = `/${conditionSlug}/${model.make}/${model.model}`;
                return (
                  <div
                    key={model.displayName}
                    className="text-body2Medium text-text-link-action"
                  >
                    <a href={slugify(href)}>{model.displayName}</a>
                  </div>
                );
              })}
            </div>
          </Accordion>
        </div>
      </div>
    </ResponsiveWrapper>
  );
};
